module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "list-view"
  }, [_c('div', {
    staticClass: "item-container"
  }, [_vm._t("default")], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e307f242!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list-view.vue
// module id = 200
// module chunks = 5